import { Link, useLoaderData } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import { Header } from "../../components/layout/Header";
import { LinkButton } from "../../components/common";
import type { DashboardData } from "../../routes/loaders";
import styles from "./DashboardPage.module.css";

export default function DashboardPage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { podcasts } = useLoaderData() as DashboardData;

  const orgs = user?.organizations ?? [];
  // If user has exactly one org, link directly to podcast creation; otherwise go to org list
  const createLink =
    orgs.length === 1
      ? `/organizations/${orgs[0].id}/podcasts/create`
      : "/organizations";

  return (
    <>
      <Header />
      <div className="container">
        <div className={styles.header}>
          <h1>{t("dashboard.title")}</h1>
          <LinkButton to={createLink} variant="primary" size="sm">
            Create Podcast
          </LinkButton>
        </div>

        {podcasts.length === 0 ? (
          <div className={styles.emptyState}>
            <h2>Welcome to Poddify!</h2>
            <p>You don't have any podcasts yet. Create your first podcast to get started.</p>
            <LinkButton to={createLink} variant="primary">
              Get Started
            </LinkButton>
          </div>
        ) : (
          <div className={styles.podcastsGrid}>
            {podcasts.map((podcast) => (
              <Link
                key={podcast.id}
                to={`/organizations/${podcast.organizationId}/podcasts/${podcast.id}`}
                className={styles.podcastCard}
              >
                <h3>{podcast.name}</h3>
                {podcast.description && (
                  <p className={styles.podcastDescription}>{podcast.description}</p>
                )}
                <p className={styles.podcastMeta}>
                  {podcast.category || "Uncategorized"} · {podcast.language.toUpperCase()}
                  {orgs.length > 1 && (
                    <> · {podcast.organizationName}</>
                  )}
                </p>
              </Link>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
